import { IMongoDocument } from "@/types"
import { ICurrency } from "../balanceAPI"
import { IDeckHandCard } from "../deckAPI"
import { IActiveEffect } from "../effectsAPI"
import { IGameplayStateResponse } from "../gameplayAPI"

export type IMatchSessionStatus =
  | "PENDING"
  | "ACTIVE"
  | "FINISHED"
  | "CANCELLED"

type IMatchSearchStatus = "SEARCHING" | "MATCHED" | "ALREADY_IN_MATCH"

export const enum MATCH_SOCKETS {
  MATCH_FOUND = "match_found",
  SESSION_READY = "session_ready",
  SEARCH_CANCELLED = "search_cancelled",
  MATCH_FINISHED = "match_finished",
  SESSION_CONFIRM = "session_confirm"
}

export const enum MATCH_VARIANTS_SOCKETS {
  Q_UPDATED = "q_updated"
}

type IMatchReason = "RESIGN" | "WIN" | "AUTOLOSE"

export interface IMatchSession {
  sessionId: string
  player1: string
  player2: string
  status: IMatchSessionStatus
  winner: string
  reward: null
  reason: IMatchReason
  matchedAt: string | null
  startedAt: string | null
  finishedAt: string | null
}

export interface IMatchSearchResponse {
  status: IMatchSearchStatus
  session?: IMatchSession
}

export interface IMatchSessionSnapshot {
  state: IGameplayStateResponse
  activeEffects: IActiveEffect[]
  hands: IDeckHandCard[]
}

export interface IMatchPot extends IMongoDocument {
  sessionId: string
  tournamentId: string | null
  buyInValue: number
  buyInCurrency: ICurrency
  totalPot: number
  commissionPercent: number
  prizeValue: number
  prizeCurrency: ICurrency
  resolved: boolean
}

export interface IMatchSessionResponse {
  status: IMatchSessionStatus
  sessionId: string
  opponentId: string
  youAre: string
  winner?: string
  reason?: IMatchReason
  snapshot?: IMatchSessionSnapshot
  player1?: string
  player2?: string
  pot?: IMatchPot
  reward?: Record<string, { goldenDust: number }> | null
}

export interface IMatchSearchEvent extends IMatchSessionResponse {}

export interface IMatchAverageSearchTime {
  averageWaitMs: number
  averageWaitSec: number
}

// *** Bid Variants ***
export const COMMON_BID_VARIANT_ID = "64b500000000000000000001"
export interface IMatchBidVariant extends IMongoDocument {
  buyInValue: number
  buyInCurrency: ICurrency
  commissionPercent: number
  imgSrc: string
}

export interface IMatchRoomPlayersCountSocket {
  type: "Q_UPDATED"
  data: Record<string, number>
}

export interface IMatchRoomPlayersCount {
  counts: Record<string, number>
}

export enum MATCH_CONFIRM_SESSION_STATUS {
  EXPIRED = "EXPIRED"
}

export enum MATCH_CONFIRM_SESSION_PLAYER_STATUS {
  CONFIRMED = "CONFIRMED",
  PENDING = "PENDING",
  REJECTED = "REJECTED"
}

export interface IMatchConfirmSessionPlayer {
  playerId: string
  status: MATCH_CONFIRM_SESSION_PLAYER_STATUS
}

export interface IMatchConfirmSessionResponse {
  ok: boolean
  sessionId: string
  expiresAt: number
  playerA: IMatchConfirmSessionPlayer
  playerB: IMatchConfirmSessionPlayer
  reason?: MATCH_CONFIRM_SESSION_STATUS
}
